import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { injectReducer } from "store/reducers";
import { routes } from "Projects/config/routes";
import ProjectDetailsStep from "./routes/ProjectDetailsStep";
import AcademicHonesty from "./routes/AcademicHonesty";
import Assessment from "./routes/Assessment";
import ProcessJournal from "./routes/ProcessJournal";
import RPPF from "./routes/RPPF";
import Action from "./routes/Action";
import Presentation from "./routes/Presentation";
import Reflection from "./routes/Reflection";
import ReportV2 from "./routes/ReportV2";
import CEStages from "./routes/CEStages";
const {
  projectDetails: { path },
} = routes;
const ProjectDetailsRoute = store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
          import(
            /* webpackChunkName: "project-group" */ "IBPlanner/modules/IBPlannerModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const plannerReducer = importedModule1.default;
          injectReducer(store, {
            key: "planner",
            reducer: plannerReducer,
          });
          return withDynamicUrlValidation({
            component,
            urlValidationType: "number",
          });
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      Assessment(store),
      AcademicHonesty(store),
      ProcessJournal(store),
      RPPF(store),
      Action(store),
      Presentation(store),
      Reflection(store),
      ReportV2(store),
      CEStages(store),
      ProjectDetailsStep(store), //Keep static screens before ProjectDetailsStep in this array.
    ],
  };
};
export default ProjectDetailsRoute;
